import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { updatePlans } from '@custom/rtk-apis/Setting/plans/updatePlans';
import { Plan } from '../plans/getPlanSlice';

// Define the state interface
export interface PlansState {
  plans: Plan[];
  loading: boolean;
  error: string | null;
  success: boolean;
}

// Initial state
const initialState: PlansState = {
  plans: [],
  loading: false,
  error: null,
  success: false
};

// Create the slice
const updatePlansSlice = createSlice({
  name: 'updatePlans',
  initialState,
  reducers: {
    resetSuccess: (state) => {
      state.success = false;
    },
    resetError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updatePlans.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updatePlans.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.plans = action.payload;
        state.success = true;
      })
      .addCase(updatePlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = false;
      });
  }
});

export default updatePlansSlice.reducer;
export const { resetSuccess, resetError } = updatePlansSlice.actions;
